const state = () => {
  return {
    isBusy: false,
    history: {
      timeline: {},
      category: ""
    },
    memos: ""
  };
};

const getters = {
  isBusy: state => state.isBusy,
  history: state => state.history,
  memos: state => state.memos
};

const actions = {};

//mutations
const mutations = {
  setBusy(state) {
    state.isBusy = true;
  },
  resetBusy(state) {
    state.isBusy = false;
  },
  setHistory(state, history) {
    state.history = history;
  },
  resetHistory(state) {
    state.history = {
      timeline: {},
      category: ""
    };
  },
  setMemos(state, memos) {
    state.memos = memos;
  },
  resetMemos(state) {
    state.memos = "";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
